var React = require('react');

function Camera (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.64 11.291c0 .015 0 .06-.056.084-.056.024-.088-.01-.099-.02L15.28 8.15v-.272l3.205-3.205a.083.083 0 0 1 .099-.02.083.083 0 0 1 .056.084v6.554zm-4.32 1.75c0 .66-.539 1.2-1.2 1.2H2.56c-.661 0-1.2-.54-1.2-1.2V2.96c0-.661.539-1.2 1.2-1.2h10.56c.661 0 1.2.539 1.2 1.2v10.08zm4.631-9.275a1.046 1.046 0 0 0-1.144.228L15.28 6.52V2.96c0-1.191-.969-2.16-2.16-2.16H2.56C1.37.8.4 1.769.4 2.96v10.08c0 1.191.97 2.16 2.16 2.16h10.56c1.191 0 2.16-.969 2.16-2.16V9.507l2.527 2.527a1.046 1.046 0 0 0 1.144.228c.395-.163.65-.544.65-.97V4.736c0-.426-.255-.808-.65-.97z","fill":"#fff"}));
}

Camera.defaultProps = {"width":"20","height":"16","fill":"none"};

module.exports = Camera;

Camera.default = Camera;
